/**
 * The `mergeParams` for a widget's `description` — the same key the rest of
 * the app already uses for a positional merge list.
 *
 * An entry naming a field reads it off the state; one prefixed with `$` reads it
 * and formats it as an amount in the org's locale. Two widgets use it, and it
 * used to be exported from one of them — so deleting that widget would have
 * taken a helper the other depends on with it (33.2 step 11).
 */
const retrieveParams = (params, state, lf) => {
    let result = []

    params.forEach(p => {
        let value = p
        if (p.includes('$')) {
            value = p.replace('$', '')
            //This formats Amount values...in params starting with $
            result.push(lf(state[value], 2, 2))
        } else result.push(state[value])
    })
    return result
}

export { retrieveParams }
export default retrieveParams
